import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full text-print-base" }
const _hoisted_2 = { class: "print-mb2" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "прийому-передачі виконаних робіт (наданих послуг)", -1)
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Ми, що нижче підписалися, Виконавец - фізична особа-підприємець Федічкін Олександр Володимирович з однієї сторони і Замовник ")
const _hoisted_7 = { class: "print-ml font-bold" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex\"><div class=\"w-1/4 flex-shrink-0 print-border-b print-mr\"></div><div class=\"flex-shrink-0 print-mr\">в особі директора</div><div class=\"flex-grow print-border-b\"></div></div><div class=\"flex\"><div class=\"flex-grow print-border-b print-mr\"></div><div class=\"flex-shrink-0\">з другої сторони, уклали цей акт про те, що Виконавець виконав роботи</div></div><div class=\"flex\"><div>(надав послуги) згідно договору №</div><div class=\"w-1/12 print-border-b print-mr print-ml\"></div><div>від</div><div class=\"w-1/6 print-border-b print-ml\"></div></div>", 3)
const _hoisted_11 = { class: "break-inside-avoid" }
const _hoisted_12 = { class: "print-mb3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center print-mb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "print-border-b w-10/12" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "print-mb" }, "Роботи (послуги) виконані повністю, сторони перетензій одна до одної не мають.", -1)
const _hoisted_15 = { class: "flex print-mb2" }
const _hoisted_16 = { class: "w-7/12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Роботу здав", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "Виконавець", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "w-5/12" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Роботу прийняв"),
  /*#__PURE__*/_createElementVNode("div", null, "Замовник")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-7/12" }, [
    /*#__PURE__*/_createElementVNode("div", null, "М.П."),
    /*#__PURE__*/_createElementVNode("div", null, "Підпис")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-5/12" }, [
    /*#__PURE__*/_createElementVNode("div", null, "М.П."),
    /*#__PURE__*/_createElementVNode("div", null, "Підпис")
  ])
], -1)

import { RepairOrderClosedResource } from '@shared/resources/repair-order';
import { START_DOCUMENT_NUMBER } from 'client/src/components/print/constants';
import { PrintTable, PrintTableColumn } from '../components/table'
import { computed } from 'vue';
import { coinsFormat, floatFormat } from '@shared/helpers/data-converters/number-converters';
import { useI18n } from 'vue-i18n';
import { QtyUnitNameMap } from '@shared/types/qty-unit';
import { dateInWords, numberInWords } from '../helpers/number-in-words';
import Creds from './partials/Creds.vue';
import { countItemPrice } from '@shared/helpers/sum';
import { timestampToDate } from '@/helpers/datetime';

interface Props {
  order: RepairOrderClosedResource;
  numericDate?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PrintInvoiceRepairNew',
  props: {
    order: null,
    numericDate: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  order: RepairOrderClosedResource;
  numericDate?: boolean;
}

const { t } = useI18n();



const date = computed(() => {
  const date = props.order.date as number;
  if (props.numericDate) {
    return timestampToDate(date);
  }
  return dateInWords(date);
});

const rows = computed(() => {
  const { items } = props.order;

  return items.map((item, index) => {
    return {
      index: index + 1,
      name: item.name,
      unit: t(`common.units.${QtyUnitNameMap[item.qtyType]}`),
      qty: floatFormat(item.qty),
      price: coinsFormat(item.price),
      sum: coinsFormat(countItemPrice(item)),
    };
  });
})
const columns = computed<PrintTableColumn[]>(() => {
  return [
    {
      title: '№',
      data: 'index',
    },
    {
      title: 'Найменування',
      data: 'name',
    },
    {
      title: 'Один.вим.',
      data: 'unit',
    },
    {
      title: 'К-сть',
      data: 'qty',
    },
    {
      title: 'Ціна без ПДВ',
      data: 'price',
    },
    {
      title: 'Сума без ПДВ',
      data: 'sum',
    },
  ];
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "Акт № " + _toDisplayString(__props.order.id + _unref(START_DOCUMENT_NUMBER)), 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, "складений " + _toDisplayString(_unref(date)), 1),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.order.client.name), 1)
      ]),
      _hoisted_8
    ]),
    _createVNode(_unref(PrintTable), {
      columns: _unref(columns),
      rows: _unref(rows),
      class: "print-mb"
    }, null, 8, ["columns", "rows"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", null, "Разом, без ПДВ " + _toDisplayString(_unref(coinsFormat)(__props.order.sum)) + " грн.", 1),
      _createElementVNode("div", _hoisted_12, "Всього прописом (" + _toDisplayString(_unref(numberInWords)(Number(__props.order.sum))) + ")", 1),
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createVNode(Creds, {
            "hide-title": "",
            "hide-bank": "",
            "show-iban-label": "",
            "show-mfo": ""
          })
        ]),
        _hoisted_19
      ]),
      _hoisted_20
    ])
  ]))
}
}

})